import React from 'react';
import MainLayout from 'src/components/MainLayout/MainLayout';

const SettingsAndPrivacyPage = (): JSX.Element => {
  return (
    <MainLayout isPrivate isPrivateInnerFull>
      <h2>SettingsAndPrivacy</h2>
    </MainLayout>
  );
};

export default SettingsAndPrivacyPage;
